/**
 * Brand Configuration Interfaces
 * Defines the structure for white-label brand configurations
 */

/**
 * Available brand identifiers
 */
export enum Brand {
  DeleteMe = 'deleteme',
}

export interface CompanyInfo {
  name: string;
  address: string;
  city: string;
  country: string;
}

export interface BrandConfig {
  brand: {
    name: Brand;
    displayName: string;
    tagline?: string;
  };

  company: {
    usa: CompanyInfo;
    europe: CompanyInfo;
  };

  urls: {
    main: string;
    terms: string;
    privacy: string;
    privacyCenter: string;
    help: string;
    contact: string;
  };

  emails: {
    sales: string;
    support: string;
    databrokers?: string;
  };

  whatsapp: WhatsAppContact[];

  chat: {
    enabled: boolean;
    widgetId?: string;
    scriptUrl?: string;
  };

  features: FeatureFlags;
  menu: MenuConfig;
  digitalFootprint: DigitalFootprintConfig;
  theme: ThemeConfig;
}

export interface WhatsAppContact {
  region: string;
  display: string;
  link: string;
}

export interface FeatureFlags {
  // Removal services
  dataBrokerRemovals: boolean;
  dataBreachRemovals: boolean;
  dataBreachSubscription: boolean;
  searchEngineRemovals: boolean;
  customRemovals: boolean;
  doxbinRemovals: boolean;
  kycRemovals: boolean;

  // Reports
  digitalFootprintReports: boolean;
  breachLeakReports: boolean;
  privacyMeterReports: boolean;
  enhancedReputationReports: boolean;

  // Subscriptions
  alertSubscriptions: boolean;

  // Other
  privacyCenter: boolean;
  billing: boolean;
  contactUs: boolean;
}

export interface MenuConfig {
  items: BrandMenuItem[];
}

export interface BrandMenuItem {
  id: string;
  label: string;
  icon: string;
  routerLink?: string;
  externalUrl?: string;
  visible: boolean;
  featureFlag?: keyof FeatureFlags;
  children?: BrandMenuItem[];
}

export interface DigitalFootprintConfig {
  categories: DigitalFootprintCategory[];
}

export interface DigitalFootprintCategory {
  key: string;
  title: string;
  description: string;
}

export interface ThemeConfig {
  primaryColor: string;
  primaryColorPalette: ColorPalette;
  logo: string;
  logoIcon: string;
  favicon: string;
}

export interface ColorPalette {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  950: string;
}
